import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Analytics from '../../../lib/user-analytics';
import DropDown from '../../Shared/dropdown';
import { ImagerySortOptions } from '../Imagery/imagery-options';

interface NavigationFilterInputProps {
    placeholderText: string;
    filterValue: string;
    setFilterValue: (filterValue: string) => void;
    setSortValue?: (sortValue: string | undefined) => void;
    handleClearFilter: () => void;
}

const NavigationFilterInput = (props: NavigationFilterInputProps) => {
    const { placeholderText, setFilterValue, setSortValue, handleClearFilter } = props;
    const [inputValue, setInputValue] = useState<string>('');

    useEffect(() => {
        setFilterValue(inputValue.toLowerCase())
    }, [inputValue, setFilterValue])

    const handleClearInput = () => {
        setInputValue('');
        handleClearFilter();
    }

    return (
        <ProfileNavigationFilterContainer>
            <FilterInputContainer>
                <FilterInput
                    placeholder={placeholderText}
                    value={inputValue}
                    onChange={(e) => {
                        setInputValue(e.target.value);
                        Analytics.Event('Explore', 'Clicked filter input', e.target.value);
                    }}
                />
                <ClearIcon className="fa fa-times" onClick={handleClearInput} />
            </FilterInputContainer>
            <DropDownContainer>
                <DropDown
                    name="SortBy"
                    options={ImagerySortOptions.options}
                    title={ImagerySortOptions.title}
                    handleSelectedOptions={(options) => {
                        const sortValue = options ? options[0] : undefined;
                        Analytics.Event(
                            'Explore',
                            'Clicked imagery sort option',
                            `${ImagerySortOptions.title} - ${sortValue}`
                        );

                        if (setSortValue) {
                            setSortValue(sortValue?.value);
                        }
                    }}
                    isRadio={true}
                    icons={{
                        light: ImagerySortOptions.icons.light,
                        dark: ImagerySortOptions.icons.dark,
                    }}
                />
            </DropDownContainer>
        </ProfileNavigationFilterContainer>
    );
};

export default NavigationFilterInput;

const ProfileNavigationFilterContainer = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    @media only screen and (max-width: 600px) {
        margin-left: 5px;
        margin-right: 5px;
    }
`;

const FilterInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;

    @media only screen and (max-width: 600px) {
        position: relative;
    }
`;

const FilterInput = styled.input`
    display: block;
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.3);
    background: transparent;
    padding: 4px;
    color: rgba(255, 255, 255, 0.6);
    -webkit-text-fill-color: rgba(255, 255, 255, 0.6);
    border-radius: 6px;

    :hover,
    :active,
    :focus,
    :focus-visible {
        background-color: transparent;
        border: 1px solid rgba(238, 217, 38, 0.6) !important;
        box-shadow: 0 0 0 0.1rem rgba(238, 217, 38, 0.3) !important;
        color: rgba(255, 255, 255, 0.6) !important;
        outline: none;
    }
`;

const ClearIcon = styled.i`
    position: absolute;
    float: right;
    cursor: pointer;
    color: rgba(255,255,255,0.6);
    padding: 9px 7px;
    font-size: 16px;
`;

const DropDownContainer = styled.div`
    padding-left: 10px;
    width: 290px;
    display: flex;
    align-items: center;

    @media only screen and (max-width: 600px) {
        width: 50px;
    }
`;
